import React from 'react';

const DashboardContext = React.createContext({
  dashboards: [],
  selectedDashboard: null,
  setSelectedDashboard: null,
  displayDashboard: true,
  selectedSubscriberKey: null
});

export default DashboardContext;
